import { render, staticRenderFns } from "./HomeFashionView.vue?vue&type=template&id=090a1a65&scoped=true&"
import script from "./HomeFashionView.vue?vue&type=script&lang=js&"
export * from "./HomeFashionView.vue?vue&type=script&lang=js&"
import style0 from "./HomeFashionView.vue?vue&type=style&index=0&id=090a1a65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a1a65",
  null
  
)

export default component.exports